import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IListSupplierFetchParams,
  ISupplier,
  MN_SUPPLIERS,
} from '@jobcost-monorepo/crud';

export default function SuppliersPage() {
  return (
    <Grid<ISupplier, IListSupplierFetchParams>
      moduleName={MN_SUPPLIERS}
      updateStore={false}
    ></Grid>
  );
}
